import { AxiosResponse } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { useHttpClient } from "../../../../shared/http/HttpClientProvider";
import { MutationOptions, MutationResult } from '../../../../shared/types/query';
import { KEY_PUBLIC_API_TOKEN_LIST } from './useGetTokens';

const KEY_DELETE_PUBLIC_API_TOKEN = 'configuration/key_delete_public_api_token';

export function useDeleteToken(options?: MutationOptions<string, AxiosResponse>): MutationResult<string, AxiosResponse> {
  const http = useHttpClient();
  const queryClient = useQueryClient();

  return useMutation({
    ...options,
    mutationKey: [KEY_DELETE_PUBLIC_API_TOKEN],
    mutationFn: async (clientId: string) => {
      return http.request({
        method: 'delete',
        url: `ApiClient/${clientId}`,
      })
    },
    onSuccess: () => {
      void queryClient.invalidateQueries([KEY_PUBLIC_API_TOKEN_LIST])
    }
  })
}